import { Input } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useRef, useState } from "react";

function onChangeSeCompleto(newArray, onChange) {
  let codigoCompleto = newArray.join("").trim();

  if (codigoCompleto.length === 6) {
    onChange(codigoCompleto);
  }
}

function InputCode({ onChange, initial, error }) {
  let arrayInicial = Array.apply(0, Array(6));
  if (initial) {
    arrayInicial = initial.split("");
  }

  const [arrayCode, setArrayCode] = useState(arrayInicial);
  const itemsRef = useRef([]);

  const onChangeHandle = async (e, posicao) => {
    const { value: numero } = e.target;

    let array = [...arrayCode];
    array[posicao] = numero;

    setArrayCode(array);

    onChangeSeCompleto(array, onChange);

    if (posicao === 5 || !numero) return;

    let itemRef = itemsRef.current[posicao + 1];

    itemRef.focus();
    itemRef.select();
  };

  const onPasteHandle = (e, posicao) => {
    e.preventDefault();

    let newArray = [...arrayCode];

    let arrayColado = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .split("");

    arrayColado.forEach((v) => {
      newArray[posicao] = v;
      posicao++;
    });

    newArray = newArray.slice(0, 6);

    setArrayCode(newArray);

    onChangeSeCompleto(newArray, onChange);
  };

  return (
    <div className="input-code">
      {arrayCode.map((numero, i) => (
        <span key={i}>
          <label className="sr-only " htmlFor={`code-${i}`}>
            {`${i + 1}º caractere`}
          </label>
          <Input
            autoFocus={i === 0}
            defaultValue={numero}
            className="field"
            error={error}
            ref={(ref) => itemsRef.current.push(ref)}
            id={`code-${i}`}
            maxLength="1"
            onChange={(e) => onChangeHandle(e, i)}
            onPaste={(e) => onPasteHandle(e, i)}
          />
        </span>
      ))}
    </div>
  );
}

InputCode.propTypes = {
  onChange: PropTypes.func.isRequired,
  initial: PropTypes.string,
  error: PropTypes.bool,
};

export default InputCode;
